import React from 'react';
import PropTypes from 'prop-types';

const GroupJoinSVGR = ({ className }) => (
  <svg
    width='48'
    height='48'
    viewBox='0 0 48 48'
    className={className}
  >
    <path
      fill='#19a683'
      d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z'
      opacity='0.33'
    />
    <path
      fill='#00604b'
      d='M26.52 22.44A7.436 7.436 0 0028 18c0-1.247-.338-2.408-.877-3.445A5.208 5.208 0 0130.25 13.5a5.247 5.247 0 015.25 5.25 5.247 5.247 0 01-8.98 3.69zM40 34.457c0 .867-.67 1.542-1.5 1.542H32c.322-.473.5-1 .5-1.626 0-2.963-1.35-5.607-3.5-7.374h3.458C36.644 27 40 30.356 40 34.458zM22.877 26.25A8.124 8.124 0 0131 34.374c0 .9-.727 1.626-1.627 1.626H11.625A1.625 1.625 0 0110 34.374a8.123 8.123 0 018.123-8.124zM14.5 18a6 6 0 1112 0 6 6 0 01-12 0z'
    />
  </svg>
);

GroupJoinSVGR.propTypes = {
  className: PropTypes.string,
};

GroupJoinSVGR.defaultProps = {
  className: '',
};

export default GroupJoinSVGR;
